<template>
  <scroll-bar>
    <div class="pingtai" @click="handleGoPingtai" v-if="isShowBig==1">省级劳动教育大数据平台</div>
    <el-menu mode="vertical" :show-timeout="200" :default-active="$route.path" :unique-opened="true"
      :collapse="isCollapse" background-color="#ffffff" text-color="#000000" active-text-color="#FFDB58">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers',
      'isBigData'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    isShowBig(){
      return window.localStorage.getItem('isBigData')
    }
  },
  methods:{
    handleGoPingtai(){
      window.open('http://big.laodongxuetang.com/#/home')
    }
  }
}
</script>
<style>
  .pingtai{
    width: 100%;
    height: 56px;
    color: #000000;
    z-index: 100;
    display: block;
    text-align: center;
    line-height: 56px;
    font-size: 14px;
    cursor: pointer;
  }
  .pingtai:hover{
    background-color: rgb(204,204,204);
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue